import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import BigModal from '../../../../components/Modals/BigModal'
import AddAgendaPopup from './AddAgendaPopup'
import { GlobalContext } from '../../../../App'
import { useNavigate } from 'react-router-dom'
import MeetingInfo from './MeetingInfo'
import MeetingAgenda from './MeetingAgenda'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import { Alert } from '@mui/material'

const NewMeeting = () => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [location, setLocation] = useState('')
  const [type, setType] = useState('')
  const [invitees, setInvitees] = useState([])
  const [inviteeOptions, setInviteeOptions] = useState([])
  const [agendaItems, setAgendaItems] = useState([])
  const [openAddAgendaPopup, setOpenAddAgendaPopup] = useState(false)
  const { setToast } = useContext(GlobalContext)

  const navigate = useNavigate()

  useEffect(() => {
    API.post('/users-in-team')
      .then((res) => res.status === 200 && setInviteeOptions(res.data))
      .catch((e) => console.log(e))
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/governance/meetings', {
      startTime: startDate,
      endTime: endDate,
      meetingType: type,
      location,
      invitees: invitees.reduce((accumulator, person) => {
        accumulator.push(person._id)
        return accumulator
      }, []),
      agenda: agendaItems.reduce((accumulator, item, index) => {
        accumulator.push({
          order: index + 1,
          title: item.title,
          description: item.description,
          lead: item.lead.reduce((accumulator, person) => {
            accumulator.push(person._id)
            return accumulator
          }, []),
          cqcKLOE: item.cqcKLOE,
          estimatedTime: item.estimatedTime,
        })
        return accumulator
      }, []),
    }).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Meeting Created' })
        navigate('/meetings/' + res.data.meetingID)
      } else {
        setToast({ message: 'Unable to create meeting', severity: 'error' })
      }
    })
  }

  return (
    <>
      <Stack component="form" onSubmit={handleSubmit} gap={2}>
        <MeetingInfo
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          type={type}
          setType={setType}
          location={location}
          setLocation={setLocation}
          invitees={invitees}
          setInvitees={setInvitees}
          inviteeOptions={inviteeOptions}
        />
        {type ? (
          <MeetingAgenda
            agendaItems={agendaItems}
            setAgendaItems={setAgendaItems}
            inviteeOptions={inviteeOptions}
            setOpenAddAgendaPopup={setOpenAddAgendaPopup}
            meetingType={type}
          />
        ) : (
          <Alert severity="info">Please select a Meeting Type</Alert>
        )}
        <Paper sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                type="submit"
                color="success"
                fullWidth
                variant="contained"
                disabled={agendaItems.length === 0}
              >
                Create Meeting
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Stack>
      <BigModal
        open={!!openAddAgendaPopup}
        onClose={() => setOpenAddAgendaPopup(false)}
      >
        <AddAgendaPopup
          staffOptions={invitees}
          setAgendaItems={setAgendaItems}
          onClose={() => setOpenAddAgendaPopup(false)}
          agendaItems={agendaItems}
        />
      </BigModal>
    </>
  )
}

export default NewMeeting
